import React, {Component} from 'react';
import CKEditor from "react-ckeditor-component";
import EmailPreview from "./EmailPreview";
import $ from 'jquery';

class EmailEditor extends Component {
    constructor(props) {
        super(props);
        this.updateContent = this.updateContent.bind(this);
        this.state = {
            course: 0,
            content: (this.props.courses[0].email) ? this.props.courses[0].email.student : '',
            previewModalIsOpen: false,
            role: 'student',
            courses: this.props.courses
        }
    }

    updateContent = (newContent) => {
        this.setState({
            content: newContent
        })
    };

    setNewEmail = (role, course) => {
        let {courses} = this.state;

        courses[this.state.course].email[this.state.role] = this.state.content;

        this.setState({
            role,
            course: course,
            courses: courses,
            content: this.state.courses[course].email[role]
        }, () => {
            this.ckeditor.editorInstance.setData(this.state.content);

        })
    }

    onChange = (evt) => {
        let newContent = evt.editor.getData();
        let {courses} = this.state;
        courses[this.state.course].email[this.state.role] = this.state.content;

        this.setState({
            content: newContent,
            courses: courses
        });
    };

    onBlur = (evt) => {
    };

    afterPaste = (evt) => {
    };

    handleModalOpenState = () => {
        this.state.content !== '' &&
        this.setState({
            previewModalIsOpen: !this.state.previewModalIsOpen
        });
    };

    render() {
        return (
            <div className="panel customPanel sm-bottom0">
                <div className='panel-heading border-bottom'>
                    <h3 className="panel-title text-uppercase font-400">
                        <span className="font-16">
                            <i className="zmdi zmdi-email"/>
                            Template Email
                        </span>
                    </h3>
                </div>
                <div className="panel-body">

                    <div className="row">

                        <div className="col-md-6">
                    <div className="form-group">
                        <div className="btn-group" data-toggle="button">
                            <a onClick={(e) => this.setNewEmail('instructor', this.state.course)}
                               className={(this.state.role == 'instructor') ? "btn btn-danger active w-sm" : "btn btn-default active w-sm"}>Instructor</a>
                            <a onClick={(e) => this.setNewEmail('student', this.state.course)}
                               className={(this.state.role == 'student') ? "btn btn-danger active w-sm" : "btn btn-default active w-sm"}>Student</a>

                        </div>
                    </div>
                        </div>
                        <div className="col-md-6 text-right">
                            <select className="form-control"
                                    onChange={(e) => this.setNewEmail(this.state.role, e.target.value)}
                            >

                                {this.props.courses.map((c, i) => {
                                    return (
                                        <option value={i}>{c.name}</option>
                                    )
                                })}
                            </select>
                        </div>
                    </div>
                    <div className="form-group">

                        <CKEditor
                            ref={instance => { this.ckeditor = instance; }}
                            id="editor"
                            activeclassName="p10"
                            content={this.state.content}
                            events={{
                                "afterPaste": this.afterPaste,
                                "change": this.onChange
                            }}
                        />

                    </div>

                    <div className="form-group text-right no-margin text-edit-btns">
                        <a className="btn btn-default w-xs">
                            <i className="zmdi zmdi-close"/>
                            Cancel
                        </a>
                        <a
                            // className="btn btn-default w-xs"
                            className={`btn btn-default w-xs ${this.state.content === '' && 'email-preview-empty'}`}
                            onClick={this.handleModalOpenState}
                        >
                            <i className="zmdi zmdi-eye"/>
                            Preview
                        </a>
                        <a className="btn btn-base w-xs" onClick={(e) => this.props.saveEmail(this.state.courses)}>
                            <i className="zmdi zmdi-save"/>
                            Save
                        </a>
                    </div>

                    {
                        this.state.previewModalIsOpen &&
                        <EmailPreview
                            content={this.state.content}
                            onCloseModal={this.handleModalOpenState}
                        />
                    }

                </div>
            </div>
        )
    }
}

export default EmailEditor;


// WEBPACK FOOTER //
// ./src/components/AdminPanel/People/EmailEditor.js